import { IGLAccountData } from '@/models';
import { IGLAccountService } from './accounting.types';
import { AxiosInstance } from 'axios';

export class GLAccountService implements IGLAccountService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/accounting/accounts/';
  }

  fetchGLAccounts(): Promise<IGLAccountData[]> {
    return this.axios
      .get<IGLAccountData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchGLAccount(id: number): Promise<IGLAccountData> {
    return this.axios
      .get<IGLAccountData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createGLAccount(data: IGLAccountData): Promise<IGLAccountData> {
    return this.axios
      .post<IGLAccountData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateGLAccount(data: IGLAccountData): Promise<IGLAccountData> {
    return this.axios
      .patch<IGLAccountData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteGLAccount(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
